var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleHint = function SvgCircleHint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.598c0 3.037-2.462 5.5-5.5 5.5S.5 9.635.5 6.598c0-3.038 2.462-5.5 5.5-5.5s5.5 2.462 5.5 5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.442 5.804c.349-.281.558-.537.558-.99v.001c0-.529-.366-.896-.984-.896-.671 0-1.15.392-1.141 1.331H3.75c-.027-1.33.819-2.252 2.273-2.252 1.499 0 2.126.827 2.126 1.757 0 .818-.383 1.245-.915 1.681l-.496.4c-.244.197-.323.274-.323.572v.385H5.388v-.547c0-.546.122-.674.584-1.058l.47-.384zm.131 2.799v1.195h-1.35V8.603h1.35z",
    clipRule: "evenodd"
  })));
};
export default SvgCircleHint;